import { useContext } from 'react' 
import { Route, Switch, Redirect } from 'react-router-dom'

import { Dashboard, Documents, Templates, SettingsProfile, Signatures, SingleDocument, SettingsAgency, SettingsCoverPage, Help, RegisteredMailTracking, RegisteredMailSender, StandardTemplates, StandardTemplateDetail, ToDoList } from '../pages'
import { ResponseLoader } from '../components/ui_new'
import { LoaderContext, SingleDocumentState, UserContext } from '../context'
import { FEATURE, availableOn, isFeatureEnabled } from '../utils'
import WhatsNew from '../components/pages/support/WhatsNew'
import HelpPage from '../components/pages/support/Help'
import Documentation from '../components/pages/support/Documentation'
import HelpCategory from '../components/pages/support/HelpCategory'
import HelpArticle from '../components/pages/support/HelpArticle'
import HelpSearchResults from '../components/pages/support/HelpSearchResults'
import WhatsNewArticle from '../components/pages/support/WhatsNewArticle'
import DocumentationArticle from '../components/pages/support/DocumentationArticle'
import NotFound from '../components/pages/NotFound'

const AppRoutes = ({ token }) => {
  const { showDashboardOverlay, showGlobalResponseLoader, globalResponseLoaderText } = useContext(LoaderContext)  
  const { user, partner, showSignatures, integration } = useContext(UserContext)

  const editorCode = () => {
    if(partner === 'jurisur') {
      return 'ac3'
    }
    return partner
  }

  return (
    <div className="app-wrapper" data-editeur-code={editorCode()}>
      {showDashboardOverlay && <div className="overlay"></div>}
      {showGlobalResponseLoader && <ResponseLoader text={globalResponseLoaderText} />}
      <Switch>
        {partner && <Route path="/" exact>
          <Dashboard />
        </Route>}
        {partner && <Route path="/documents" exact>
          <Documents />
        </Route>}
        {partner && <Route path="/documents/:id" exact>
          <SingleDocumentState>
            <SingleDocument token={token} pageTitle={"Rédaction d'un document"}/>
          </SingleDocumentState>
        </Route>}
        {partner && <Route path="/document-detail/:id" exact>
          <SingleDocumentState>
            <SingleDocument token={token} pageTitle={"Rédaction d'un document"}/>
          </SingleDocumentState>
        </Route>}
        <Route path="/document-revision/:id" exact>
          <SingleDocumentState publicView>
            <SingleDocument token={token} layout="public" />
          </SingleDocumentState>
        </Route>
        {partner && <Route path="/templates" exact>
          <Templates />
        </Route>}
        {partner && <Route path="/templates/:id" exact>
          <SingleDocumentState>
            <SingleDocument token={token} pageTitle={"Rédaction d'un document"}/>
          </SingleDocumentState>
        </Route>}
        {partner && <Route path="/template/:id" exact>
          <SingleDocumentState>
            <SingleDocument token={token} pageTitle={"Rédaction d'un document"}/>
          </SingleDocumentState>
        </Route>}
        {partner && <Route path="/standard-templates" exact>
          <StandardTemplates standard />
        </Route>}
        {partner && <Route path="/standard-templates/:id" exact>
          <SingleDocumentState>
            <StandardTemplateDetail token={token} />
          </SingleDocumentState>
        </Route>}
        {showSignatures && partner && <Route path="/signatures" exact>
          <SingleDocumentState>
            {/* Including single document state here because SingleDocumentSignVialink modal is used in Signatures page */}
              <Signatures />
          </SingleDocumentState>
        </Route>}
        
        {partner && <Route path="/settings/profile" exact>
          <SettingsProfile />
        </Route>}
        {partner && <Route path="/settings/my-profile" exact>
          <SettingsProfile />
        </Route>}
        {partner && <Route path="/settings/agency" exact>
          <SettingsAgency />
        </Route>}
        {isFeatureEnabled(FEATURE.COVER_PAGE_SETTINGS, integration) && partner && <Route path="/settings/cover-page" exact>
          <SettingsCoverPage />
        </Route>}
        {availableOn(['development', 'staging']) && partner && <Route path="/help" exact>
          <Help />
        </Route> }
        <Route path="/what-is-new" exact>
          <WhatsNew v2 />
        </Route>
        {availableOn(['development', 'staging']) && partner && <Route path="/help-center" exact>
          <HelpPage v2 />
        </Route> }
        <Route path="/documentation" exact>
          <Documentation v2 />
        </Route>
        {availableOn(['development', 'staging']) && partner && <Route path="/help-category/:id" exact>
          <HelpCategory v2 />
        </Route> }
        {availableOn(['development', 'staging']) && partner && <Route path="/help-article/:id" exact>
          <HelpArticle v2 />
        </Route>}
        {availableOn(['development', 'staging']) && partner && <Route path="/what-is-new" exact>
          <WhatsNew v2 />
        </Route>}
        {availableOn(['development', 'staging']) && partner && <Route path="/help-center" exact>
          <HelpPage v2 />
        </Route>}
        {availableOn(['development', 'staging']) && partner && <Route path="/documentation" exact>
          <Documentation v2 />
        </Route>}
        {availableOn(['development', 'staging']) && partner && <Route path="/help-category/:id" exact>
          <HelpCategory v2 />
        </Route>}
        {availableOn(['development', 'staging']) && partner && <Route path="/help-article/:id" exact>
          <HelpArticle v2 />
        </Route>}
        {availableOn(['development', 'staging']) && partner && <Route path="/help-search-results" exact>
          <HelpSearchResults v2 />
        </Route>}
        {availableOn(['development', 'staging']) && partner && <Route path="/what-is-new/:id" exact>
          <WhatsNewArticle v2 />
        </Route>}
        {availableOn(['development', 'staging']) && partner && <Route path="/documentation/:id" exact>
          <DocumentationArticle v2 />
        </Route>}

        {isFeatureEnabled(FEATURE.AR24, integration) && partner && <Route path="/registered-mail/tracking" exact>
          <RegisteredMailTracking />
        </Route>}
        {isFeatureEnabled(FEATURE.AR24, integration) && partner && isFeatureEnabled(FEATURE.AR24_SENDER_MANAGEMENT, integration) && <Route path="/registered-mail/sender" exact>
          <RegisteredMailSender />
        </Route>}
        {isFeatureEnabled(FEATURE.AR24, integration) && partner && <Route path="/registered-mail" exact>
          <Redirect to="/registered-mail/tracking" />
        </Route>}

        {isFeatureEnabled(FEATURE.DOCUMENT_VALIDATION, integration) && partner && <Route path="/to-do" exact>
          <ToDoList />
        </Route>}
        {(partner || user.uid) && <Route path="*">
          <NotFound v2 />
        </Route>}
      </Switch>
    </div>
  )
}

export default AppRoutes 